/** Class used to filter shops. */

export class Shop {

    /** Shop ID. */
    public id: number;

    /** Shop name. */
    public name: string;

    /** Quantity of products still available in this shop. */
    public quantityProducts: number;

    constructor(id = NaN, name = "", quantityProducts = 0) {
        this.id = id;
        this.name = name;
        this.quantityProducts = quantityProducts;
    }
}